import React, { useState } from 'react'
import DateTimePicker from 'react-native-modal-datetime-picker'
import { useTheme } from '@ui-kitten/components'
import { useStyleSheet, StyleService } from '@src/style/service'
import { useIsDarkMode } from '@config/theme'
import { formatDate, FULL_DATE_TIME_FORMAT } from '@config/momentFormat'
import { PillButton } from '@screens/Meals'
import { Global } from '@utils'

interface DatePickerProps {
  testID?: string
  date: Date
  setDate: (date: Date) => void
}

export const DatePicker = ({ testID, date, setDate }: DatePickerProps) => {
  const theme = useTheme()
  const styles = useStyleSheet(themedStyle)
  const isDarkMode = useIsDarkMode()

  const [isVisible, setPickerVisible] = useState(false)

  const onConfirm = (date: Date) => {
    setPickerVisible(false)
    setDate(date)
  }

  return (
    <>
      <PillButton
        icon="calendar-blank"
        text={formatDate(date, FULL_DATE_TIME_FORMAT)}
        testID={testID}
        accessibilityLabel="Meal Time"
        onPress={() => setPickerVisible(true)}
      />
      <DateTimePicker
        isDarkModeEnabled={isDarkMode}
        date={Global.toLocalTimezoneDate(date)}
        isVisible={isVisible}
        onConfirm={onConfirm}
        onCancel={() => setPickerVisible(false)}
        mode="datetime"
        textColor={theme['theme.text.primary']}
        pickerContainerStyleIOS={styles.pickerContainerIOS}
        themeVariant={isDarkMode ? 'dark' : 'light'}
      />
    </>
  )
}

const themedStyle = StyleService.create({
  pickerContainerIOS: {
    backgroundColor: 'theme.secondary.base',
  },
})
